import { BorderRadius, Color, rwd, Spacing, Text } from '@billy/design-system'
import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
`

export const List = styled.ol`
  width: 100%;
  margin-left: ${Spacing.S40};
  overflow: hidden;

  ${rwd.equalOrLessThan('xlarge')} {
    margin-left: ${Spacing.S24};
  }
`

interface ListItemProps {
  clickable?: boolean
  color: Color
}

export const ListItem = styled.li<ListItemProps>`
  display: flex;
  align-items: center;
  padding: ${Spacing.S8} 0;
  border-bottom: 1px solid ${Color.Grey200};
  list-style: none;

  &:before {
    content: '';
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-right: ${Spacing.S12};
    border-radius: ${BorderRadius.R4};
    background: ${({ color }) => color};
  }

  &:last-of-type {
    border-bottom: 0;
  }
`

// TODO retheming 2026 - get rid of (Text), which is an antipattern
export const Label = styled(Text)`
  margin-right: auto;
`

// TODO retheming 2026 - get rid of (Text), which is an antipattern
export const Amount = styled(Text)`
  flex-shrink: 0;
  margin-left: ${Spacing.S8};
`
